var _rect, _rect2, _path, _circle, _path2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepairingServiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.05872,
    y: 9.88232,
    width: 9.26842,
    height: 90.7512,
    rx: 4.63421,
    transform: "rotate(-45 2.05872 9.88232)",
    fill: "#9BDFBF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9045,
    y: 63.9191,
    width: 51.5074,
    height: 19.1167,
    transform: "rotate(-45 19.9045 63.9191)",
    fill: "#036235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0794 1.96458L68.4475 16.9615L82.1306 30.3114L96.7713 15.3055C97.5441 17.4194 98.0041 19.6885 98.0935 22.0589C98.5532 34.2417 89.0497 44.4905 76.8669 44.9501C64.6841 45.4098 54.4353 35.9063 53.9757 23.7234C53.516 11.5406 63.0195 1.29191 75.2024 0.832265C77.9572 0.728327 80.6132 1.13384 83.0794 1.96458Z",
    fill: "#09B162"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6219,
    cy: 76.8514,
    r: 13.1219,
    stroke: "#09B162",
    strokeWidth: 13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9021 67.1581L66.7537 52.3065L97.1716 82.7244C98.7337 84.2865 98.7337 86.8191 97.1716 88.3812L87.9768 97.576C86.4147 99.1381 83.8821 99.1381 82.32 97.576L51.9021 67.1581Z",
    fill: "#FFC200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6019,
    y: 68.2309,
    width: 29.4328,
    height: 6.56815,
    rx: 1,
    transform: "rotate(-45 46.6019 68.2309)",
    fill: "#30334F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3184,
    y: 71.2277,
    width: 2.45274,
    height: 24.5274,
    rx: 1.22637,
    transform: "rotate(-45 61.3184 71.2277)",
    fill: "#30334F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.2239,
    y: 68.7749,
    width: 2.45274,
    height: 24.5274,
    rx: 1.22637,
    transform: "rotate(-45 66.2239 68.7749)",
    fill: "#30334F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6766,
    y: 63.8694,
    width: 2.45274,
    height: 24.5274,
    rx: 1.22637,
    transform: "rotate(-45 68.6766 63.8694)",
    fill: "#30334F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairingServiceIcon);
export default __webpack_public_path__ + "static/media/repairing_service_icon.27978924fece6d288dbce122a957e57a.svg";
export { ForwardRef as ReactComponent };